export default __webpack_public_path__ + "static/media/sounds/TRO_Done_Answering.mp3";